// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3NMhb","inner":"Footer_inner__ksVus","nextIcon":"Footer_nextIcon__2pHif","innerLeft":"Footer_innerLeft__2KaTf"};